import getCart from './getCart'
import openModal from './openModal'

export const ExtendWarranty = {
  initXPDP(productSku) {
    window.ExtendWarrantyService = ExtendWarranty

    // Add timeout to ensure add to cart button has finished rendering
    this.productOptionsElement = document.querySelector('#add-to-cart-form .product-options')
    this.addToCartButton = document.querySelector('#form-action-addToCart')
    window.Extend.buttons.destroyAll()
    window.Extend.buttons.render('#extend-offer', { referenceId: productSku })

    const url = new URL(window.location.href)
    if (url.searchParams.get('sku')) {
      this.processVariant(url.searchParams.get('sku'))
    }
  },
  async processVariant(sku) {
    window.Extend?.buttons.instance('#extend-offer')?.setActiveProduct(sku)
  },
  getCart,
  openModal,
  async getOffer(sku) {
    return window.Extend.getOffer(sku)
  },
  async isExtendProduct(sku) {
    const offer = await window.Extend.getOffer(sku)
    return Boolean(offer.product.title)
  },
  createCartWithProduct(productId) {
    const data = JSON.stringify({
      action: 'add',
      product_id: productId,
      'qty[]': 1,
    })

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      xhr.withCredentials = true

      xhr.addEventListener('readystatechange', function () {
        if (this.readyState === this.DONE) {
          resolve({ status: xhr.status, data: xhr.response })
        }
      })
      xhr.addEventListener('error', (event) => {
        reject(event)
      })
      // TODO: Migrate to V3
      xhr.open('POST', 'remote/v1/cart/add')
      xhr.setRequestHeader('content-type', 'application/json')
      xhr.responseType = 'json'
      xhr.send(data)
    })
  },
  initXMiniCart() {
    if (window.Extend && window.ExtendBigCommerce) {
      window.ExtendBigCommerce.getCart((error, cart) => {
        if (cart) {
          window.ExtendBigCommerce.normalizeCart({ cart, balance: true }, () => { })
        }
      })
    }
  },
  extendCatalogOffers(cartUrl) {
    if (window.Extend && window.ExtendBigCommerce) {
      document.querySelector('[data-button-type="add-cart"]').on('click', (e) => {
        e.preventDefault()
        e.stopImmediatePropagation()

        const sku = e.currentTarget.getAttribute('data-product-sku')
        const productId = e.currentTarget.getAttribute('data-product-id')
        const href = e.currentTarget.getAttribute('href')

        window.ExtendBigCommerce.getCart((_, cart) => {
          if (cart) {
            window.Extend.modal.open({
              referenceId: sku,
              onClose: (plan, product) => {
                if (plan && product) {
                  window.ExtendBigCommerce.addPlanToCart({ sku, plan, cart }, () => {
                    window.location = href
                  })
                } else {
                  window.location = href
                }
              },
            })
          } else {
            ExtendWarranty.createCartWithProduct(productId).then((res) => {
              if (!res.data) {
                window.location = cartUrl
                return
              }
              window.Extend.modal.open({
                referenceId: sku,
                onClose: (plan, product) => {
                  if (plan && product) {
                    window.ExtendBigCommerce.addPlanToCart({ sku, plan }, () => {
                      window.location = cartUrl
                    })
                  } else {
                    window.location = cartUrl
                  }
                },
              })
            })
          }
        })
      })
    }
  },
}

export default ExtendWarranty
